import * as React from "react";

export const PageLayout: React.FC = (props) => {
  return <div style={{ padding: "var(--padding, 0 1rem 1rem)" }}>{props.children}</div>;
};

export default PageLayout;
